import React, { useState } from "react";
import "../src/App.css";

export default function EditQuestionForm({
  initialQuestion,
  onCancel,
  onSubmit,
}) {
  const [editedQuestion, setEditedQuestion] = useState(initialQuestion); 
  console.log("Value of initialQuestion:", initialQuestion);

  return (
    <div className="edit-container">
      <textarea
        className="edit-textarea"
        value={editedQuestion}
        onChange={(e) => setEditedQuestion(e.target.value)}
        rows={4}
        placeholder={editedQuestion} // Use the placeholder prop here
      />
      <button className="editSubmit" onClick={() => onSubmit(editedQuestion)}>
        Submit
      </button>
      <button className="editCancel" onClick={onCancel}>
        Cancel
      </button>
    </div>
  );
}
